import LlenarEncuesta from "pages/LandingPages/LlenarEncuesta/llenarEncuesta";

export default function LlenarEncuestaPage() {
  return <LlenarEncuesta />;
}
